/**
 * @param {FormData} formData
 */
async function addComment(formData) {
    return request('/blog-article/comment', {
        method: 'post',
        body: formData,
    });
}

/**
 * @param {string} articleId
 */
async function addLike(articleId) {
    return request(`/blog-article/like?id=${articleId}`);
}

/**
 * @param {string} query
 */
async function search(query) {
    return request(`/ajax/search?query=${query}`);
}

/**
 * @param {string} path
 * @param {RequestInit} [options]
 */
async function request(path, options) {
    const response = await fetch(path, options);
    const body = await response.text();

    if (!response.ok) {
        const isHtmlBody = body.trimStart().startsWith('<');
        const statusText = response.statusText || String(response.status);

        throw new Error(isHtmlBody ? statusText : body);
    }

    return body;
}

export {addComment, addLike, search};
